import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import ClauseComponentReducer from './DocumentView/Component/ClauseComponent/Reducer/clauseComponentRed';
import ClauseComponentWatcher from './DocumentView/Component/ClauseComponent/Saga/clauseComponentSaga';
import documentViewReducer from './DocumentView/Component/DocumentViewSlice';
import clauseTermReducer from './DocumentView/Reducer/clauseTermSlice';
import documentReducer from './DocumentView/Reducer/documentRed';
import DocumentWatcher from './DocumentView/Saga/documentSaga';
import draftViewReducer from './Draft/Component/DraftViewSlice';
import designationApiReducer from './Redux/DesignationApiSlice';
import designationReducer from './Redux/DesignationSlice';
import insightReducer from './Redux/InsightSlice';
import locationApiReducer from './Redux/LocationApiSlice';
import locationReducer from './Redux/LocationSlice';
import reportReducer from './Redux/ReportSlice';
import stampReducer from './Redux/StampSlice';
import tatReducer from './Redux/TatConfigSlice';
import HeimdallReducer from './UniversalComponents/HeimdallChild/Reducer/heimdallReducer';

const sagaMiddleWare = createSagaMiddleware();

export const createStore = (
  options?: ConfigureStoreOptions['preloadedState'] | undefined
) =>
  configureStore({
    reducer: {
      heimdall: HeimdallReducer,
      document: documentReducer,
      clauseComponent: ClauseComponentReducer,
      documentView: documentViewReducer,
      draftView: draftViewReducer,
      location: locationReducer,
      designation: designationReducer,
      locationApi: locationApiReducer,
      designationApi: designationApiReducer,
      stamp: stampReducer,
      clauseTerm: clauseTermReducer,
      report: reportReducer,
      tat: tatReducer,
      insights: insightReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action types
          ignoredActions: [
            'splitApi/executeQuery/fulfilled',
            'auth/setInstance',
          ],
        },
      }).concat(sagaMiddleWare),
    ...options,
  });

export const store = createStore();

sagaMiddleWare.run(DocumentWatcher);
sagaMiddleWare.run(ClauseComponentWatcher);

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
